import React, { useState, useEffect, useCallback } from "react";
import { toast } from "react-toastify";

import { Header, Input, Grid, Button, Form, DropdownProps, Label, InputOnChangeData } from "semantic-ui-react";


import TableApp, { ITableAppRender } from "../../components/TableApp";
import MaskedInput from "../../components/MaskedInput";

import { IKit, IPedido } from "../../interfaces";
import KitRepository from "../../Repositories/KitRepository";
import OrderRepository from "../../Repositories/OrderRepository";
import RegionalManagerRepository, { IRegionalManagerListModel } from "../../Repositories/RegionalManagerRepository";
import SectorManagerRepository, { ISectorManagerListModel } from "../../Repositories/SectorManagerRepository";
import AgentsRepository, { IAgentListModel } from "../../Repositories/AgentsRepository";

import NumberFormat from "../../Utils/NumberFormat";
import errors from "../../Utils/ExtractErrors";
import { RouteComponentProps } from "react-router-dom";
import { format } from "date-fns";
import TemplateMain from "../../components/TemplateMain";
import ReciboPedido from "./ReciboPedido";

interface IItemModel extends IKit {
    item: number;
    valorCurrency: string;
    isNew: boolean;
    warning: boolean;
}

interface IKitEdit extends IKit {
    isNew: boolean
}

interface State extends IPedido {

}

interface Props {
    id: string;
}

const initialState: State = {
    id: "",
    acerto: "",
    codigo: 0,
    data: "",
    gerenteRegionalId: "",
    gerenteSetorId: "",
    representanteId: "",
    status: 0
}

const CadastrarPedido: React.FC<RouteComponentProps<Props>> = ({ match }) => {

    const [loading, setLoading] = useState<boolean>(false);
    const [saving, setSaving] = useState<boolean>(false);
    const [stateKit, setStateKit] = useState<IKit[]>([]);
    const [numero, setNumero] = useState<string>("");

    const [state, setState] = useState<State>(initialState);
    const [items, setItems] = useState<IKitEdit[]>([]);
    const [tableList, setTablelist] = useState<IItemModel[]>([]);

    const [regionalManagers, setRegionalManagers] = useState<IRegionalManagerListModel[]>([]);
    const [sectorManagers, setSectorManagers] = useState<ISectorManagerListModel[]>([]);
    const [agents, setAgents] = useState<IAgentListModel[]>([]);

    const LoadPedido = useCallback(async () => {
        setLoading(true);
        try {
            const [pedido, kits] = await Promise.all([
                OrderRepository.GetById(match.params.id),
                KitRepository.ListByPedidoId(match.params.id)
            ])

            setState({
                ...pedido,
                acerto: format(new Date(pedido.acerto), "dd/MM/yyyy")
            });

            const pedidoKits = kits as IKitEdit[];

            setItems(pedidoKits);
        } catch (err) {
            if (err.response.status === 401) {
                window.location.href = "/";
            }

            const error = errors.getAllErrors(err.response.data);

            if (error !== undefined)
                toast(error, { position: "top-center", type: "error" });
        }
        setLoading(false);
    }, [match.params.id]);

    useEffect(() => { LoadPedido(); }, [LoadPedido]);

    const LoadKits = useCallback(async () => {
        try {
            const result = await KitRepository.ListStocked();

            setStateKit(result);
        } catch (err) {
            if (err.response.status === 401) {
                window.location.href = "/";
            }

            const error = errors.getAllErrors(err.response.data);

            if (error !== undefined)
                toast(error, { position: "top-center", type: "error" });
        }
    }, []);

    useEffect(() => { LoadKits(); }, [LoadKits]);

    const LoadRegionalManagers = useCallback(async () => {
        try {
            const result = await RegionalManagerRepository.List({
                filter: "Status == 1"
            });

            setRegionalManagers(result.list);
        } catch (err) {
            if (err.response.status === 401) {
                window.location.href = "/";
            }

            const error = errors.getAllErrors(err.response.data);

            if (error !== undefined)
                toast(error, { position: "top-center", type: "error" });
        }
    }, []);

    useEffect(() => { LoadRegionalManagers(); }, [LoadRegionalManagers]);

    const LoadSectorManagers = useCallback(async () => {
        try {
            if (state.gerenteRegionalId.length > 0) {
                const result = await SectorManagerRepository.List({
                    filter: `GerenteRegionalId == "${state.gerenteRegionalId}" && Status == 1`
                });

                setSectorManagers(result.list);
            }
        } catch (err) {
            if (err.response.status === 401) {
                window.location.href = "/";
            }

            const error = errors.getAllErrors(err.response.data);

            if (error !== undefined)
                toast(error, { position: "top-center", type: "error" });
        }
    }, [state.gerenteRegionalId]);

    useEffect(() => { LoadSectorManagers(); }, [LoadSectorManagers]);

    const LoadAgents = useCallback(async () => {
        try {
            if ((state.gerenteSetorId || "").length > 0) {
                const result = await AgentsRepository.List({
                    filter: `GerenteSetorId == "${state.gerenteSetorId}" && Status == 1`
                });

                setAgents(result.list);
            }
        } catch (err) {
            if (err.response.status === 401) {
                window.location.href = "/";
            }

            const error = errors.getAllErrors(err.response.data);

            if (error !== undefined)
                toast(error, { position: "top-center", type: "error" });
        }
    }, [state.gerenteSetorId]);

    useEffect(() => { LoadAgents(); }, [LoadAgents]);

    const handleOnChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setNumero(e.target.value);
    }

    const handleOnKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.key === "Enter")
            handleAddItem();
    }

    const handleAddItem = () => {
        const duplicatedItem = items.find(x => x.numero === Number(numero));

        if (duplicatedItem) {
            toast(`Kit nº ${duplicatedItem.numero} já adicionado`, { position: "top-center", type: "error" });
        } else {
            const item = stateKit.find(x => x.numero === Number(numero)) as IKitEdit;

            if (item !== undefined) {
                let addKit = false;

                if (item.statusKit === 2) {
                    if (item.prorrogado === 1) {
                        toast(`Kit nº ${numero} não pode mais ser prorrogado`, { position: "top-center", type: "error" });
                    } else {
                        item.prorrogado = 1;
                        addKit = true;
                    }
                } else {
                    addKit = true;
                }

                if (addKit) {
                    setNumero("");
                    item.isNew = true;
                    setItems([item, ...items]);
                }
            }
            else {
                toast(`Kit nº ${numero} não encontrado`, { position: "top-center", type: "error" });
            }
        }
    }

    const handleRemoveItem = (index: number) => {
        const item = items.find((x, i) => i === index);

        if (item !== undefined) {
            const newItems = items.filter((x, i) => i !== index);

            setItems(newItems);
        }
    }

    const removeButton = (index: number, isNew: boolean) => <Button disabled={!isNew} icon="trash" color="red" onClick={() => handleRemoveItem(index)} />

    const handleTableData = useCallback(() => {

        let data: IItemModel[] = [];
        let contador: number = items.length;

        items.map((kit) => {
            return data.push({
                item: contador--,
                ...kit,
                warning: kit.prorrogado === 1,
                valorCurrency: NumberFormat.Currency(kit.valor),
            });
        });

        setTablelist(data);
    }, [items]);

    const handleFinalizar = async () => {
        setSaving(true);

        try {
            const response = await OrderRepository.Update({
                id: match.params.id,
                orderPutModel: {
                    acerto: state.acerto,
                    gerenteSetorId: state.gerenteSetorId,
                    representanteId: state.representanteId,
                    status: state.status
                },
                kits: items.filter(item => item.statusKit <= 2)
            });

            toast(`🎉 ${response.message}`, { position: "top-center", type: "success" });
            LoadPedido();
        } catch (err) {
            if (err.response.status === 401) {
                window.location.href = "/";
            }

            const error = errors.getAllErrors(err.response.data);

            if (error !== undefined)
                toast(error, { position: "top-center", type: "error" });
        }

        setSaving(false);
    }

    const setWarning = (prorrogado: number, numero: number) => {
        if (prorrogado === 1) {
            return <Label icon="warning sign" color="orange" size="large" content={numero} />
        } else {
            return numero;
        }
    }

    useEffect(() => { handleTableData() }, [handleTableData, items]);

    const tableRender: ITableAppRender[] = [
        {
            header: "Item",
            content: (x: IItemModel) => x.item,
            textAlign: "center",
            width: 1
        },
        {
            header: "Número do kit",
            content: (x: IItemModel) => setWarning(x.prorrogado, x.numero),
            textAlign: "left",
            width: 10
        },
        {
            header: "Valor",
            content: (x: IItemModel) => x.valorCurrency,
            textAlign: "center",
            width: 1
        },
    ];

    const onSectorManagerChange = (event: React.SyntheticEvent<HTMLElement, Event>, data: DropdownProps) => {
        const { name, value } = data;

        setState(state => ({ ...state, [name]: value, representanteId: "" }));
    }

    const onAgentChange = (event: React.SyntheticEvent<HTMLElement, Event>, data: DropdownProps) => {
        const { name, value } = data;

        setState({ ...state, [name]: value });
    }

    const handleAcertoChange = (event: React.ChangeEvent<HTMLInputElement>, data: InputOnChangeData) => {
        setState(state => ({ ...state, acerto: data.value }));
    }

    const content = (
        <Grid columns="equal">
            <Grid.Row>
                <Grid.Column>
                    <Header size="huge" content={`PEDIDO: ${state.codigo}`} icon="list alternate" />
                </Grid.Column>
                <Grid.Column>
                    <MaskedInput
                        fluid
                        readOnly={items.find(item => item.statusKit >= 3) === undefined ? undefined : true}
                        mask="data"
                        icon="calendar alternate"
                        iconPosition="left"
                        placeholder="Data acerto"
                        value={state.acerto}
                        onChange={handleAcertoChange}
                    />                    
                </Grid.Column>
            </Grid.Row>
            <Grid.Row>
                <Grid.Column>
                    <Form>
                        <Form.Group widths="equal">
                            <Form.Field>
                                <Form.Dropdown
                                    fluid
                                    selection
                                    open={false}
                                    name="gerenteRegionalId"
                                    placeholder="Selecione"
                                    label="G. Regional"
                                    value={state.gerenteRegionalId}
                                    options={regionalManagers.map(regionalManager => { return { key: regionalManager.id, value: regionalManager.id, text: regionalManager.nome } })}
                                />
                            </Form.Field>
                            <Form.Field>
                                <Form.Dropdown
                                    fluid
                                    selection
                                    open={items.find(item => item.statusKit >= 3) === undefined ? undefined : false}
                                    search={items.find(item => item.statusKit >= 3) === undefined}
                                    scrolling
                                    name="gerenteSetorId"
                                    noResultsMessage="Nenhum registro encontrado."
                                    placeholder="Selecione"
                                    label="G. Setor"
                                    value={state.gerenteSetorId}
                                    onChange={onSectorManagerChange}
                                    options={sectorManagers.map(sectorManager => { return { key: sectorManager.id, value: sectorManager.id, text: sectorManager.nome } })}
                                />
                            </Form.Field>
                            <Form.Field>
                                <Form.Dropdown
                                    fluid
                                    selection
                                    open={items.find(item => item.statusKit >= 3) === undefined ? undefined : false}
                                    search={items.find(item => item.statusKit >= 3) === undefined}
                                    scrolling
                                    disabled={(state.gerenteSetorId || "").length === 0}
                                    name="representanteId"
                                    noResultsMessage="Nenhum registro encontrado."
                                    placeholder="Selecione"
                                    label="Representante"
                                    value={state.representanteId}
                                    onChange={onAgentChange}
                                    options={agents.map(agent => { return { key: agent.id, value: agent.id, text: agent.nome } })}
                                />
                            </Form.Field>
                            <Form.Field width={2}>
                                <label>Fotos</label>
                                <ReciboPedido pedidoId={state.id || ""} />
                            </Form.Field>
                        </Form.Group>
                    </Form>
                </Grid.Column>
            </Grid.Row>
            <Grid.Row>
                <Grid.Column>
                    <Input
                        fluid
                        label="Número do kit"
                        placeholder="Insira o número do kit"
                        onChange={handleOnChange}
                        onKeyDown={handleOnKeyDown}
                        value={numero}
                        action={{ icon: "add", color: "pink", onClick: handleAddItem }}
                    />
                </Grid.Column>
            </Grid.Row>
            <Grid.Row>
                <Grid.Column>
                    <Button.Group fluid>
                        <Button
                            color={state.status === 1 ? "green" : "grey"}
                            content="Ativo"
                            onClick={() => { setState({ ...state, status: 1 }) }}
                        />
                        <Button.Or text="?" />
                        <Button
                            color={state.status === 0 ? "red" : "grey"}
                            content="Inativo"
                            onClick={() => { setState({ ...state, status: 0 }) }}
                        />
                    </Button.Group>
                </Grid.Column>
                <Grid.Column>
                    <Button
                        fluid
                        icon="check"
                        color="pink"
                        content="Salvar pedido"
                        loading={saving}
                        onClick={handleFinalizar}
                    />
                </Grid.Column>
            </Grid.Row>
            <Grid.Column>
                <Grid.Row>
                    <TableApp
                        render={tableRender}
                        list={tableList}
                        actions={(data: IItemModel, index: number) => [removeButton(index, data.isNew)]}
                        loading={false}
                    />
                </Grid.Row>
            </Grid.Column>
        </Grid>
    );

    return (
        <TemplateMain
            loading={loading}
            content={content}
        />
    );
};

export default CadastrarPedido;
